"use strict";

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Error wrapper for SocksClient
 */

var SocksClientError = /*#__PURE__*/function (_Error) {
  _inherits(SocksClientError, _Error);

  var _super = _createSuper(SocksClientError);

  function SocksClientError(message, options) {
    var _this;

    _classCallCheck(this, SocksClientError);

    _this = _super.call(this, message);
    _this.options = options;
    return _this;
  }

  return _createClass(SocksClientError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.SocksClientError = SocksClientError;
/**
 * Shuffles a given array.
 * @param array The array to shuffle.
 */

function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [array[j], array[i]];
    array[i] = _ref[0];
    array[j] = _ref[1];
  }
}

exports.shuffleArray = shuffleArray;